import type { WalletAdapter, WalletConnectResult } from "../types"
import {
  connectMetaMaskTron,
  getActiveTronBackend,
  isMetaMaskTronSelected,
  readMetaMaskTronAddress,
} from "../metamask-tron"
import {
  getTronProviderWindow,
  hasTronInjection,
  readTronAddress,
  requestTronAccounts,
} from "../tron-provider"

export class TronWalletAdapter implements WalletAdapter {
  readonly id = "tron"
  readonly name = "Tron"
  readonly chain = "tron" as const

  isInstalled(): boolean {
    return hasTronInjection() || isMetaMaskTronSelected()
  }

  async connect(): Promise<WalletConnectResult> {
    if (getActiveTronBackend() === "metamask") {
      const address = await connectMetaMaskTron()
      return { address, chain: "tron" }
    }
    const address = await requestTronAccounts()
    return { address, chain: "tron" }
  }

  async disconnect(): Promise<void> {
    // Injected Tron wallets do not expose a standard disconnect; clear client-side only.
  }

  async getAddress(): Promise<string | null> {
    return readTronAddress() ?? readMetaMaskTronAddress()
  }

  async signMessage(message: string): Promise<string> {
    const tronWeb = getTronProviderWindow()?.tronWeb
    if (!tronWeb?.ready) {
      throw new Error("TronWeb not ready")
    }
    const trx = tronWeb as {
      trx?: { signMessage?: (message: string) => Promise<string> }
    }
    if (!trx.trx?.signMessage) {
      throw new Error("Tron message signing not supported")
    }
    return trx.trx.signMessage(message)
  }
}

export function createTronAdapter(): TronWalletAdapter {
  return new TronWalletAdapter()
}
